import styles from '../../styles/modules/Footer.module.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className="container">
        <div className={styles.footerContent}>
          <div className={styles.brand}>
            <div className={styles.logo}>
              <span className={styles.logoText}>picCode</span>
              <span className={styles.logoDot}>.</span>
            </div>
            <p className={styles.tagline}>
              Create beautiful code screenshots with syntax highlighting. Fast, secure, and privacy-first.
            </p>
            <a href="https://lab39.org" className={styles.backToLab39}>
              ← Back to lab39
            </a>
          </div>

          <div className={styles.links}>
            <div className={styles.linkGroup}>
              <h4 className={styles.linkTitle}>Features</h4>
              <span className={styles.link}>20+ Themes</span>
              <span className={styles.link}>20+ Languages</span>
              <span className={styles.link}>Multiple Exports</span>
              <span className={styles.link}>100% Client-Side</span>
            </div>
            
            <div className={styles.linkGroup}>
              <h4 className={styles.linkTitle}>Resources</h4>
              <span className={styles.linkDisabled}>About</span>
              <span className={styles.linkDisabled}>Privacy Policy</span>
              <span className={styles.linkDisabled}>Terms</span>
              <span className={styles.linkDisabled}>Contact</span>
            </div>
          </div>
        </div>

        <div className={styles.footerBottom}>
          <p className={styles.copyright}>
            © {currentYear} picCode · Part of lab39
          </p>
          <p className={styles.made}>
            Made with ❤️ for developers
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
